import { Controller } from "@hotwired/stimulus"

// Hides its element when dismissed and remembers the choice for the browser
// session via sessionStorage, keyed by `keyValue`. Stays hidden until the
// session ends — gentle, not permanent.
export default class extends Controller {
  static values = { key: String }

  declare keyValue: string

  connect() {
    if (this.keyValue && sessionStorage.getItem(this.storageKey) === "1") {
      this.element.remove()
    }
  }

  dismiss() {
    if (this.keyValue) {
      sessionStorage.setItem(this.storageKey, "1")
    }
    this.element.remove()
  }

  private get storageKey(): string {
    return `dismissed:${this.keyValue}`
  }
}
